import { useSearchParams } from 'react-router-dom';
import type { IModuleDefinitionState } from '@platform/core/types/modularity/IModuleDefinitionState';
import { findModule } from '@platform/modularity';
import { useGlobalRecordTypeOverrideQuery, useListRecordsQuery, useRecordTypeOverrideQuery } from '@platform/state/api';
import type { ICustomizeModulePageProps } from '../ICustomizeModulePageProps';
import { firstRecordArgs } from './firstRecordArgs';
import { formRecordType } from './formRecordType';
import { manifestFormType } from './manifestFormType';
import { useScopeDefinition } from './useScopeDefinition';

/**
 * Читання сторінки модуля в «Налаштуваннях», які стартують разом із читанням каталогу оболонки, а не після завантаження пакета модуля
 * (рішення 3 етапу 11): визначення модуля свого рівня (useScopeDefinition), а для редактора форми — перевизначення типу в просторі й
 * глобальне (дочірня таблиця з `?type=`, інакше основний тип) і перший запис для «Відкрити запис» (firstRecordArgs). Готова сторінка
 * читає ті самі записи кешу (ті самі аргументи, що в useRecordTypeEditor, useFormEditor і SettingsFormHead), тож другого запиту немає.
 * Тип — за визначенням, доки його немає — за маніфестом пакета (manifestFormType). Повертає стан визначення (шапка під час завантаження).
 */
export function useCustomizeReads(ws: string, moduleKey: string, section: ICustomizeModulePageProps['section'], global: boolean): IModuleDefinitionState {
  const [params] = useSearchParams();
  const definition = useScopeDefinition(moduleKey, global);
  const type = params.get('type');
  const known = definition.data ? formRecordType(definition.data, type)?.key ?? '' : manifestFormType(findModule(moduleKey), type);
  const rt = section === 'forms' ? known : '';
  useRecordTypeOverrideQuery({ ws, rt }, { skip: global || !ws || !rt });
  useGlobalRecordTypeOverrideQuery({ rt }, { skip: !rt });
  useListRecordsQuery(firstRecordArgs(ws, rt), { skip: global || !ws || !rt });
  return definition;
}
